import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'

const categoryMenu = [
    { name: 'Estate Planning', route: "" },
    { name: 'Estate & Trust Administration', route: "" },
    { name: 'Elder Care Planning', route: "" },
    { name: 'Estate Planning for Young Adults', route: "" },
]


const CetagorySidebar = ({ className, title, onSelectCategory, selectedCategory }) => {
    return (
        <div className={className}>
            <h3 className="sidebarTitle">{title}</h3>
            <ul>
                {categoryMenu.map((category, i) => (
                    <li key={i}>
                        <button
                            onClick={() => onSelectCategory(category.name)}
                            className={selectedCategory === category.name ? 'active' : ''}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: 15,
                                textAlign: 'left',
                                cursor: 'pointer',
                                color: selectedCategory === category.name ? '#2C2C2C' : '#000000', // Cambia color dinámico
                                fontWeight: selectedCategory === category.name ? 'bold' : 'normal',
                            }}
                        >
                            {category.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    )
}
export default CetagorySidebar